import type { ToasterProps } from "sonner";

// Sonner gives the action button `flex-shrink: 0` and the message column
// `flex: 1` (basis 0). A long action label ("Place <child> in a group") then
// squeezes the message to one character per line. The message gets a 12rem
// basis and the row wraps, so a long button moves below the message. `!` is
// needed because sonner's attribute selectors outrank a single class.
const toastButton = "!h-auto !min-h-6 !max-w-full !py-1 !text-start";

/** Shared by every `<Toaster>` mount (App, MeLayout). */
export const toastOptions: NonNullable<ToasterProps["toastOptions"]> = {
  duration: 5000,
  classNames: {
    toast: "!flex-wrap !gap-y-2",
    content: "!basis-48",
    actionButton: toastButton,
    cancelButton: toastButton,
  },
};
